/**
 * KunstFuerDichPage
 * Single-page section: postcards + sculptures the visitor can buy/order.
 */

import { useArtworks } from '@/hooks/useArtworks'
import { Markdown } from '@/components/ui/Markdown'
import { Seo } from '@/components/Seo'
import { useT, STRINGS, useLanguage, useFieldLang } from '@/context/LanguageContext'
import './ContentPage.css'

export function KunstFuerDichPage() {
  const { getSection, loading } = useArtworks()
  const section = getSection('kunst-fuer-dich')
  const t = useT()
  const { lang } = useLanguage()
  const pick = useFieldLang()

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="loading-spinner" />
        <p>{t(STRINGS.common.loading)}</p>
      </div>
    )
  }

  if (!section) {
    return (
      <div className="error-screen">
        <p>{t(STRINGS.common.notFound)}</p>
      </div>
    )
  }

  const title = pick(section.pageTitle, section.pageTitle_en) || section.pageTitle || section.title
  const description = pick(section.description, section.description_en) || section.description || ''
  const isFallback = lang === 'en' && !section.description_en

  return (
    <article className="content-page">
      <Seo
        title={title || 'Kunst für dich'}
        description={
          lang === 'en'
            ? 'Postcards and individual sculptures by Anna Sacher Santana. Choose a work that inspires, supports, and brings joy into your day.'
            : 'Postkarten und individuelle Skulpturen von Anna Sacher Santana. Wähle ein Kunstwerk, das dich in deinem Alltag inspiriert, unterstützt und Freude schenkt.'
        }
      />
      <div className="content-container content-container-prose">
        <header className="content-header content-header-prose">
          <h1>{title || section.title}</h1>
        </header>
        {isFallback && (
          <p className="content-lang-notice">{t(STRINGS.common.contentGermanOnly)}</p>
        )}
        <Markdown className="content-prose">{description}</Markdown>
      </div>
    </article>
  )
}
